/* Citations for the country nutrition snapshot shown mid-quiz.
 *
 * Rules for this file:
 *   1. Never add an entry that has not been read and verified. An invented or
 *      approximated citation on health copy is worse than no citation at all.
 *   2. `claim` must paraphrase what the source actually establishes, not what
 *      the snapshot copy wishes it said.
 *   3. Every citation lives under the country it applies to. There is no shared
 *      or fallback tier, deliberately: a reader only ever sees sources for the
 *      country they selected. A pan-European finding is repeated under each
 *      country AND phrased as pan-European, so nobody is shown a regional fact
 *      dressed up as a fact about where they live.
 *   4. Countries with no entry simply show no Sources link.
 *
 * The bar positions in quiz-country-data.js are a PersonaPath composite, not a
 * published statistic, which is why the numeric score is no longer displayed
 * next to the marker title. These citations back the prose in each marker's
 * Details panel.
 *
 * SOURCING STATUS (2026-08-13)
 *   vitamin_d  all 32 entries, Cashman 2016 (pan-European, abstract verified)
 *   iron       Denmark only
 *   omega3, magnesium, gut_health, b12, zinc, selenium — none yet
 * Adding a marker means finding a source that reports it, reading it, and
 * writing the figure it actually gives. Do not extrapolate between countries.
 */
window.COUNTRY_HEALTH_SOURCES = {
  austria: [
    {
      claim: "Across 18 standardised European population studies covering 55,844 people, 13.0% had serum 25(OH)D below 30 nmol/L and 40.4% below 50 nmol/L. This is a European figure, not a measurement for this country specifically.",
      cite: "Cashman K.D. et al., Vitamin D deficiency in Europe: pandemic?, American Journal of Clinical Nutrition 2016;103(4):1033-1044",
      url: "https://doi.org/10.3945/ajcn.115.120873"
    }
  ],
  belgium: [
    {
      claim: "Across 18 standardised European population studies covering 55,844 people, 13.0% had serum 25(OH)D below 30 nmol/L and 40.4% below 50 nmol/L. This is a European figure, not a measurement for this country specifically.",
      cite: "Cashman K.D. et al., Vitamin D deficiency in Europe: pandemic?, American Journal of Clinical Nutrition 2016;103(4):1033-1044",
      url: "https://doi.org/10.3945/ajcn.115.120873"
    }
  ],
  bulgaria: [
    {
      claim: "Across 18 standardised European population studies covering 55,844 people, 13.0% had serum 25(OH)D below 30 nmol/L and 40.4% below 50 nmol/L. This is a European figure, not a measurement for this country specifically.",
      cite: "Cashman K.D. et al., Vitamin D deficiency in Europe: pandemic?, American Journal of Clinical Nutrition 2016;103(4):1033-1044",
      url: "https://doi.org/10.3945/ajcn.115.120873"
    }
  ],
  croatia: [
    {
      claim: "Across 18 standardised European population studies covering 55,844 people, 13.0% had serum 25(OH)D below 30 nmol/L and 40.4% below 50 nmol/L. This is a European figure, not a measurement for this country specifically.",
      cite: "Cashman K.D. et al., Vitamin D deficiency in Europe: pandemic?, American Journal of Clinical Nutrition 2016;103(4):1033-1044",
      url: "https://doi.org/10.3945/ajcn.115.120873"
    }
  ],
  cyprus: [
    {
      claim: "Across 18 standardised European population studies covering 55,844 people, 13.0% had serum 25(OH)D below 30 nmol/L and 40.4% below 50 nmol/L. This is a European figure, not a measurement for this country specifically.",
      cite: "Cashman K.D. et al., Vitamin D deficiency in Europe: pandemic?, American Journal of Clinical Nutrition 2016;103(4):1033-1044",
      url: "https://doi.org/10.3945/ajcn.115.120873"
    }
  ],
  czech_republic: [
    {
      claim: "Across 18 standardised European population studies covering 55,844 people, 13.0% had serum 25(OH)D below 30 nmol/L and 40.4% below 50 nmol/L. This is a European figure, not a measurement for this country specifically.",
      cite: "Cashman K.D. et al., Vitamin D deficiency in Europe: pandemic?, American Journal of Clinical Nutrition 2016;103(4):1033-1044",
      url: "https://doi.org/10.3945/ajcn.115.120873"
    }
  ],
  denmark: [
    {
      claim: "Across 18 standardised European population studies covering 55,844 people, 13.0% had serum 25(OH)D below 30 nmol/L and 40.4% below 50 nmol/L. This is a European figure, not a measurement for this country specifically.",
      cite: "Cashman K.D. et al., Vitamin D deficiency in Europe: pandemic?, American Journal of Clinical Nutrition 2016;103(4):1033-1044",
      url: "https://doi.org/10.3945/ajcn.115.120873"
    },
    {
      claim: "Around 23% of Danish adults have a vitamin D status below 50 nmol/L, and about 11% fall below 25 nmol/L.",
      cite: "Mortensen C. et al., Vitamin D Status and Seasonal Variation among Danish Children and Adults, Nutrients 2018;10(11):1801",
      url: "https://pmc.ncbi.nlm.nih.gov/articles/PMC6265892/"
    },
    {
      claim: "Denmark sits in the Nordic band that has a four to six month winter period without enough sun exposure to start vitamin D production in the skin.",
      cite: "Mortensen C. et al., Vitamin D Status and Seasonal Variation among Danish Children and Adults, Nutrients 2018;10(11):1801",
      url: "https://pmc.ncbi.nlm.nih.gov/articles/PMC6265892/"
    },
    {
      claim: "17.7% of premenopausal Danish women had depleted iron stores (serum ferritin below 15 ug/L) and a further 23.1% had small stores (15 to 30 ug/L).",
      cite: "Milman N. et al., Iron status markers, serum ferritin and haemoglobin in 1359 Danish women, Annals of Hematology",
      url: "https://link.springer.com/article/10.1007/BF01698138"
    }
  ],
  estonia: [
    {
      claim: "Across 18 standardised European population studies covering 55,844 people, 13.0% had serum 25(OH)D below 30 nmol/L and 40.4% below 50 nmol/L. This is a European figure, not a measurement for this country specifically.",
      cite: "Cashman K.D. et al., Vitamin D deficiency in Europe: pandemic?, American Journal of Clinical Nutrition 2016;103(4):1033-1044",
      url: "https://doi.org/10.3945/ajcn.115.120873"
    }
  ],
  finland: [
    {
      claim: "Across 18 standardised European population studies covering 55,844 people, 13.0% had serum 25(OH)D below 30 nmol/L and 40.4% below 50 nmol/L. This is a European figure, not a measurement for this country specifically.",
      cite: "Cashman K.D. et al., Vitamin D deficiency in Europe: pandemic?, American Journal of Clinical Nutrition 2016;103(4):1033-1044",
      url: "https://doi.org/10.3945/ajcn.115.120873"
    }
  ],
  france: [
    {
      claim: "Across 18 standardised European population studies covering 55,844 people, 13.0% had serum 25(OH)D below 30 nmol/L and 40.4% below 50 nmol/L. This is a European figure, not a measurement for this country specifically.",
      cite: "Cashman K.D. et al., Vitamin D deficiency in Europe: pandemic?, American Journal of Clinical Nutrition 2016;103(4):1033-1044",
      url: "https://doi.org/10.3945/ajcn.115.120873"
    }
  ],
  germany: [
    {
      claim: "Across 18 standardised European population studies covering 55,844 people, 13.0% had serum 25(OH)D below 30 nmol/L and 40.4% below 50 nmol/L. This is a European figure, not a measurement for this country specifically.",
      cite: "Cashman K.D. et al., Vitamin D deficiency in Europe: pandemic?, American Journal of Clinical Nutrition 2016;103(4):1033-1044",
      url: "https://doi.org/10.3945/ajcn.115.120873"
    }
  ],
  greece: [
    {
      claim: "Across 18 standardised European population studies covering 55,844 people, 13.0% had serum 25(OH)D below 30 nmol/L and 40.4% below 50 nmol/L. This is a European figure, not a measurement for this country specifically.",
      cite: "Cashman K.D. et al., Vitamin D deficiency in Europe: pandemic?, American Journal of Clinical Nutrition 2016;103(4):1033-1044",
      url: "https://doi.org/10.3945/ajcn.115.120873"
    }
  ],
  hungary: [
    {
      claim: "Across 18 standardised European population studies covering 55,844 people, 13.0% had serum 25(OH)D below 30 nmol/L and 40.4% below 50 nmol/L. This is a European figure, not a measurement for this country specifically.",
      cite: "Cashman K.D. et al., Vitamin D deficiency in Europe: pandemic?, American Journal of Clinical Nutrition 2016;103(4):1033-1044",
      url: "https://doi.org/10.3945/ajcn.115.120873"
    }
  ],
  iceland: [
    {
      claim: "Across 18 standardised European population studies covering 55,844 people, 13.0% had serum 25(OH)D below 30 nmol/L and 40.4% below 50 nmol/L. This is a European figure, not a measurement for this country specifically.",
      cite: "Cashman K.D. et al., Vitamin D deficiency in Europe: pandemic?, American Journal of Clinical Nutrition 2016;103(4):1033-1044",
      url: "https://doi.org/10.3945/ajcn.115.120873"
    }
  ],
  ireland: [
    {
      claim: "Across 18 standardised European population studies covering 55,844 people, 13.0% had serum 25(OH)D below 30 nmol/L and 40.4% below 50 nmol/L. This is a European figure, not a measurement for this country specifically.",
      cite: "Cashman K.D. et al., Vitamin D deficiency in Europe: pandemic?, American Journal of Clinical Nutrition 2016;103(4):1033-1044",
      url: "https://doi.org/10.3945/ajcn.115.120873"
    }
  ],
  italy: [
    {
      claim: "Across 18 standardised European population studies covering 55,844 people, 13.0% had serum 25(OH)D below 30 nmol/L and 40.4% below 50 nmol/L. This is a European figure, not a measurement for this country specifically.",
      cite: "Cashman K.D. et al., Vitamin D deficiency in Europe: pandemic?, American Journal of Clinical Nutrition 2016;103(4):1033-1044",
      url: "https://doi.org/10.3945/ajcn.115.120873"
    }
  ],
  latvia: [
    {
      claim: "Across 18 standardised European population studies covering 55,844 people, 13.0% had serum 25(OH)D below 30 nmol/L and 40.4% below 50 nmol/L. This is a European figure, not a measurement for this country specifically.",
      cite: "Cashman K.D. et al., Vitamin D deficiency in Europe: pandemic?, American Journal of Clinical Nutrition 2016;103(4):1033-1044",
      url: "https://doi.org/10.3945/ajcn.115.120873"
    }
  ],
  lithuania: [
    {
      claim: "Across 18 standardised European population studies covering 55,844 people, 13.0% had serum 25(OH)D below 30 nmol/L and 40.4% below 50 nmol/L. This is a European figure, not a measurement for this country specifically.",
      cite: "Cashman K.D. et al., Vitamin D deficiency in Europe: pandemic?, American Journal of Clinical Nutrition 2016;103(4):1033-1044",
      url: "https://doi.org/10.3945/ajcn.115.120873"
    }
  ],
  luxembourg: [
    {
      claim: "Across 18 standardised European population studies covering 55,844 people, 13.0% had serum 25(OH)D below 30 nmol/L and 40.4% below 50 nmol/L. This is a European figure, not a measurement for this country specifically.",
      cite: "Cashman K.D. et al., Vitamin D deficiency in Europe: pandemic?, American Journal of Clinical Nutrition 2016;103(4):1033-1044",
      url: "https://doi.org/10.3945/ajcn.115.120873"
    }
  ],
  malta: [
    {
      claim: "Across 18 standardised European population studies covering 55,844 people, 13.0% had serum 25(OH)D below 30 nmol/L and 40.4% below 50 nmol/L. This is a European figure, not a measurement for this country specifically.",
      cite: "Cashman K.D. et al., Vitamin D deficiency in Europe: pandemic?, American Journal of Clinical Nutrition 2016;103(4):1033-1044",
      url: "https://doi.org/10.3945/ajcn.115.120873"
    }
  ],
  netherlands: [
    {
      claim: "Across 18 standardised European population studies covering 55,844 people, 13.0% had serum 25(OH)D below 30 nmol/L and 40.4% below 50 nmol/L. This is a European figure, not a measurement for this country specifically.",
      cite: "Cashman K.D. et al., Vitamin D deficiency in Europe: pandemic?, American Journal of Clinical Nutrition 2016;103(4):1033-1044",
      url: "https://doi.org/10.3945/ajcn.115.120873"
    }
  ],
  norway: [
    {
      claim: "Across 18 standardised European population studies covering 55,844 people, 13.0% had serum 25(OH)D below 30 nmol/L and 40.4% below 50 nmol/L. This is a European figure, not a measurement for this country specifically.",
      cite: "Cashman K.D. et al., Vitamin D deficiency in Europe: pandemic?, American Journal of Clinical Nutrition 2016;103(4):1033-1044",
      url: "https://doi.org/10.3945/ajcn.115.120873"
    }
  ],
  poland: [
    {
      claim: "Across 18 standardised European population studies covering 55,844 people, 13.0% had serum 25(OH)D below 30 nmol/L and 40.4% below 50 nmol/L. This is a European figure, not a measurement for this country specifically.",
      cite: "Cashman K.D. et al., Vitamin D deficiency in Europe: pandemic?, American Journal of Clinical Nutrition 2016;103(4):1033-1044",
      url: "https://doi.org/10.3945/ajcn.115.120873"
    }
  ],
  portugal: [
    {
      claim: "Across 18 standardised European population studies covering 55,844 people, 13.0% had serum 25(OH)D below 30 nmol/L and 40.4% below 50 nmol/L. This is a European figure, not a measurement for this country specifically.",
      cite: "Cashman K.D. et al., Vitamin D deficiency in Europe: pandemic?, American Journal of Clinical Nutrition 2016;103(4):1033-1044",
      url: "https://doi.org/10.3945/ajcn.115.120873"
    }
  ],
  romania: [
    {
      claim: "Across 18 standardised European population studies covering 55,844 people, 13.0% had serum 25(OH)D below 30 nmol/L and 40.4% below 50 nmol/L. This is a European figure, not a measurement for this country specifically.",
      cite: "Cashman K.D. et al., Vitamin D deficiency in Europe: pandemic?, American Journal of Clinical Nutrition 2016;103(4):1033-1044",
      url: "https://doi.org/10.3945/ajcn.115.120873"
    }
  ],
  slovakia: [
    {
      claim: "Across 18 standardised European population studies covering 55,844 people, 13.0% had serum 25(OH)D below 30 nmol/L and 40.4% below 50 nmol/L. This is a European figure, not a measurement for this country specifically.",
      cite: "Cashman K.D. et al., Vitamin D deficiency in Europe: pandemic?, American Journal of Clinical Nutrition 2016;103(4):1033-1044",
      url: "https://doi.org/10.3945/ajcn.115.120873"
    }
  ],
  slovenia: [
    {
      claim: "Across 18 standardised European population studies covering 55,844 people, 13.0% had serum 25(OH)D below 30 nmol/L and 40.4% below 50 nmol/L. This is a European figure, not a measurement for this country specifically.",
      cite: "Cashman K.D. et al., Vitamin D deficiency in Europe: pandemic?, American Journal of Clinical Nutrition 2016;103(4):1033-1044",
      url: "https://doi.org/10.3945/ajcn.115.120873"
    }
  ],
  spain: [
    {
      claim: "Across 18 standardised European population studies covering 55,844 people, 13.0% had serum 25(OH)D below 30 nmol/L and 40.4% below 50 nmol/L. This is a European figure, not a measurement for this country specifically.",
      cite: "Cashman K.D. et al., Vitamin D deficiency in Europe: pandemic?, American Journal of Clinical Nutrition 2016;103(4):1033-1044",
      url: "https://doi.org/10.3945/ajcn.115.120873"
    }
  ],
  sweden: [
    {
      claim: "Across 18 standardised European population studies covering 55,844 people, 13.0% had serum 25(OH)D below 30 nmol/L and 40.4% below 50 nmol/L. This is a European figure, not a measurement for this country specifically.",
      cite: "Cashman K.D. et al., Vitamin D deficiency in Europe: pandemic?, American Journal of Clinical Nutrition 2016;103(4):1033-1044",
      url: "https://doi.org/10.3945/ajcn.115.120873"
    }
  ],
  switzerland: [
    {
      claim: "Across 18 standardised European population studies covering 55,844 people, 13.0% had serum 25(OH)D below 30 nmol/L and 40.4% below 50 nmol/L. This is a European figure, not a measurement for this country specifically.",
      cite: "Cashman K.D. et al., Vitamin D deficiency in Europe: pandemic?, American Journal of Clinical Nutrition 2016;103(4):1033-1044",
      url: "https://doi.org/10.3945/ajcn.115.120873"
    }
  ],
  united_kingdom: [
    {
      claim: "Across 18 standardised European population studies covering 55,844 people, 13.0% had serum 25(OH)D below 30 nmol/L and 40.4% below 50 nmol/L. This is a European figure, not a measurement for this country specifically.",
      cite: "Cashman K.D. et al., Vitamin D deficiency in Europe: pandemic?, American Journal of Clinical Nutrition 2016;103(4):1033-1044",
      url: "https://doi.org/10.3945/ajcn.115.120873"
    }
  ],
  other: [
    {
      claim: "Across 18 standardised European population studies covering 55,844 people, 13.0% had serum 25(OH)D below 30 nmol/L and 40.4% below 50 nmol/L. This is a European figure, not a measurement for this country specifically.",
      cite: "Cashman K.D. et al., Vitamin D deficiency in Europe: pandemic?, American Journal of Clinical Nutrition 2016;103(4):1033-1044",
      url: "https://doi.org/10.3945/ajcn.115.120873"
    }
  ]
};
